import { LoggerAdapter } from './types';

interface LoggerServiceArguments {
    loggerAdapters: Array<LoggerAdapter>;
}

export type LoggerService = LoggerAdapter;

const createLoggerService = ({ loggerAdapters }: LoggerServiceArguments): LoggerService => ({
    log(...args) {
        this.info(...args);
    },

    info(...args) {
        loggerAdapters.forEach((loggerAdapter) => loggerAdapter.info(...args));
    },

    warn(...args) {
        loggerAdapters.forEach((loggerAdapter) => loggerAdapter.warn(...args));
    },

    error(...args) {
        loggerAdapters.forEach((loggerAdapter) => loggerAdapter.error(...args));
    },
});

export default createLoggerService;
